export default "__VITE_ASSET__8215e59d__"